import React from "react";
import { Box, Typography, Button } from "@mui/material";

const NoData = ({ refetch }) => {
  return (
    <Box
      sx={{
        minHeight: "50vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#FFFFFF",
        backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", md: "2.5rem" },
          marginBottom: "24px",
          color: "#FFFFFF",
        }}
      >
        No Data Available
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#D1D5DB",
          marginBottom: "20px",
          maxWidth: "600px",
          fontSize: { xs: "1rem", md: "1.2rem" },
        }}
      >
        It seems like there is no data available at the moment. You can try
        refreshing the page or come back later.
      </Typography>
      <Button
        variant="contained"
        onClick={refetch}
        sx={{
          backgroundColor: "#007BFF",
          color: "#FFFFFF",
          padding: "12px 28px",
          borderRadius: "50px",
          boxShadow: "0 6px 20px rgba(0, 123, 255, 0.3)",
          "&:hover": {
            backgroundColor: "#0056b3",
            transform: "scale(1.05)",
            boxShadow: "0 8px 24px rgba(0, 86, 179, 0.4)",
          },
        }}
      >
        Refresh Data
      </Button>
    </Box>
  );
};

export default NoData;
